import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ModalDialogBody,
  ModalDialogButtons,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
  Typography,
} from '@vp/swan';
import { ReplaceTokens, useTranslations } from '@vp/om-translations';
import { BasicPreloader } from '../BasicPreloader';
import useSiteData from '../../../hooks/useSiteData';
import { EmbeddableLinkCreator } from '../EmbeddableLinkCreator';

const Footer = ({ onRequestDismiss }) => {
  const [sharedActionMessages] = useTranslations(['sharedActionMessages']);
  return (
    <ModalDialogFooter>
      <ModalDialogButtons pinned>
        <Button
          skin="primary"
          size="mini"
          variant="full-width"
          onClick={onRequestDismiss}
        >
          {sharedActionMessages.close}
        </Button>
      </ModalDialogButtons>
    </ModalDialogFooter>
  );
};
Footer.propTypes = {
  onRequestDismiss: PropTypes.func.isRequired,
};

export const AddressUpdateConfirmation = ({
  updateRequestFailure,
  updateRequestSuccess,
  onRequestDismiss,
}) => {
  const [shippingAddressUpdate] = useTranslations(['shippingAddressUpdate']);

  const { externalAppNavigation } = useSiteData();
  const navToCustomerCare = externalAppNavigation.customerCareContact;
  const ContactCareLink = EmbeddableLinkCreator({
    href: navToCustomerCare,
    tabIndex: 0,
  });

  if (!updateRequestFailure && !updateRequestSuccess) {
    return (
      <ModalDialogBody>
        <BasicPreloader isCentered />
      </ModalDialogBody>
    );
  }

  if (updateRequestFailure) {
    return (
      <>
        <ModalDialogHeader>
          <ModalDialogTitle>
            {shippingAddressUpdate.couldNotBeUpdated}
          </ModalDialogTitle>
        </ModalDialogHeader>
        <ModalDialogBody>
          <Typography mt={6} fontSize="standard">
            <ReplaceTokens
              tokenizedString={updateRequestFailure.details}
              substitutions={{
                ContactCareLink,
              }}
            />
          </Typography>
        </ModalDialogBody>
        <Footer onRequestDismiss={onRequestDismiss} />
      </>
    );
  }

  if (updateRequestSuccess) {
    return (
      <>
        <ModalDialogHeader>
          <ModalDialogTitle>
            {shippingAddressUpdate.updateRequestSent}
          </ModalDialogTitle>
        </ModalDialogHeader>
        <ModalDialogBody>
          <Typography mt={6} fontSize="standard">
            {shippingAddressUpdate.updateRequestSentDetails}
          </Typography>
        </ModalDialogBody>
        <Footer onRequestDismiss={onRequestDismiss} />
      </>
    );
  }

  return null;
};

AddressUpdateConfirmation.propTypes = {
  updateRequestFailure: PropTypes.any,
  updateRequestSuccess: PropTypes.any,
  onRequestDismiss: PropTypes.func.isRequired,
};
